module.exports = __webpack_public_path__ + "static/media/  (93).1cff9c7c.jpg";